import { Button } from "@heroui/react";
import { bodyMuted, btnPrimary, glow } from "@/components/ui/design";

export default function ConnectionIssue() {
    return (<div className="relative isolate flex min-h-[700px] flex-col items-center justify-center overflow-hidden bg-white px-4 py-20 text-center dark:bg-nightBg">
        <div className={glow} />
        <img src="/nointernet.svg" className="h-[120px] w-[120px] opacity-90 sm:h-[156px] sm:w-[156px]" />
        <div className="mt-8 max-w-[900px] text-[clamp(44px,8vw,96px)] font-bold leading-[0.95] tracking-[-0.05em] text-grey10 dark:text-white">No internet connection</div>
        <div className={`${bodyMuted} mt-6 mb-8 max-w-[480px] font-semibold`}>Please check your internet connection and try again.</div>
        <Button onPress={() => window.location.href = '/'} variant="flat" className={btnPrimary}>Homepage</Button>
    </div>)
}
